import axios from "axios";
import { genURL } from "../../_getjson";

export default async function loadFromInDB(mid) { //โหลดฟอร์มสำหรับพิมพ์ใบเสร็จ

    if (mid === "") {
        console.log("req mid");
    }

    let url = `reportmanage/reportform/${mid}?`
    console.log("reportmanage url", genURL(url))
    let res = await axios.get(genURL(url))

    let data = []
    if (res.data.length > 0) {
        // await this.setState({ reporturl: res.data[0].pathname })
        // await this.setState({ formPrintdata: res.data })

        console.log("reportmanage data pathname", res.data[0].pathname)

        await data.push({ reportUrl: res.data[0].pathname, formPrintData: res.data })
    }
    return data
}
